import apiClient from '@/services/api_client';

type AiModelEditableFields = {
    provider: string;
    model_label: string;
    params: Record<string, string>;
    input_tokens_price: number;
    output_token_price: number;
};

export type AiModel = AiModelEditableFields & {
    model_id: string;
    tenant_id: string;
    order?: number;
    allowed?: boolean;
    is_free?: boolean;
};

export type UpdateAiModelPayload = Partial<AiModelEditableFields> & {
    reorder_to?: 'up' | 'down';
    tenant_id: string;
};

export async function getAiModelCatalog(tenantId: string): Promise<AiModel[]> {
    const response = await apiClient.get(
        `/ai_models/catalog?tenant_id=${encodeURIComponent(tenantId)}`
    );
    return await response.json();
}

export async function createAiModelInCatalog(
    payload: AiModel
): Promise<AiModel> {
    return await apiClient.post('/ai_models/catalog', payload);
}

export async function updateAiModelInCatalog(
    modelId: string,
    payload: UpdateAiModelPayload
): Promise<AiModel> {
    return await apiClient.patch(
        `/ai_models/catalog/${encodeURIComponent(modelId)}`,
        payload
    );
}

export async function deleteAiModelFromCatalog(
    tenantId: string,
    modelId: string
): Promise<{ status: string }> {
    const url = `/ai_models/catalog/${encodeURIComponent(modelId)}?tenant_id=${encodeURIComponent(tenantId)}`;
    return await apiClient.delete(url, {});
}

export async function getAiModels(tenantId: string): Promise<AiModel[]> {
    const response = await apiClient.get(
        `/ai_models?tenant_id=${encodeURIComponent(tenantId)}`
    );
    return await response.json();
}

export async function getAllowedAiModels(tenantId: string): Promise<AiModel[]> {
    const response = await apiClient.get(
        `/ai_models/allowed?tenant_id=${encodeURIComponent(tenantId)}`
    );
    return await response.json();
}

export async function setModelAllowed(
    tenantId: string,
    modelId: string,
    allowed: boolean
): Promise<void> {
    await apiClient.post('/ai_models', {
        tenant_id: tenantId,
        model_id: modelId,
        allowed
    });
}
